import { Form, Input } from "decorator-form";
import { css } from "styled-components";

import InputType from "common/form/InputType";
import SubFormWidget from "common/form/widgets/SubFormWidget";

/**
 * @author chills
 * @description reusable config for basic block styles. See {@link SubFormWidget}
 */

@Form({title: "Tag Styles"})
export class TagStylesConfig {

    @Input({type: InputType.COLOR, title: "Background Color"})
	public backgroundColor?: string;

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color?: string;

	@Input({type: InputType.MARGIN, title: "Margin"})
	public margin?: string;

}

// use this as your input type
export const TagStylesInput = SubFormWidget.registerForm(TagStylesConfig);

// convert to TemplateStringArray for styled-components
export function toBlockCss(data: TagStylesConfig) {
	return data ? css`
        background-color: ${data.backgroundColor};
		color: ${data.color};
		margin: ${data.margin};
	` : undefined;
}



// WEBPACK FOOTER //
// ./src/common/views/common/TagStylesConfig.ts